import HistoryTab from 'components/Content/BeautyInsider/BeautyInsiderHistory/HistoryTab';

export default HistoryTab;
